import React, { useEffect, useState } from 'react'
import classes from '../styles.module.scss'
import { leftMenuItems } from '../../../../consts/navigation.conts'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ChevronRightIcon, NavbarItemIcon } from '../../../../assets/icons'
import { useUser } from '../../../../contexts/user.context'
import { useKato } from '../../../../contexts/kato.context'
import { KatoType } from '../../../../types/kato.types'

const snpLevelItems = [
    {
        key: 'projects',
        link: 'projects',
    },
    {
        key: 'SNP_IMPROVEMENT',
        link: 'SNP_IMPROVEMENT',
    },
    {
        key: 'snp-info',
        link: 'snp-info',
    }
]

const Navbar = () => {
    const { t } = useTranslation();
    const { kato, link } = useParams<{ kato: string, link: string }>();
    const navitage = useNavigate();
    const { isModulePresent } = useUser()
    const { currentLevel } = useKato();
    const [links, setLinks] = useState<{ key: string; link: string }[]>(leftMenuItems);

    const handleItemClick = (item: { key: string; link: string }) => {
        if (!kato) return;
        navitage(`/${kato}/${item.link}`);
    };

    useEffect(() => {
        if (currentLevel === KatoType.VILLAGE) {
            setLinks(snpLevelItems);
        } else {
            setLinks(leftMenuItems);
        }
    }, [currentLevel, kato]);

    return (
        <div className={classes.navbar}>
            {links.map((item) => (
                isModulePresent(item.key) && <div key={item.key} className={`${classes.navbar__item} ${link === item.key ? classes['navbar__item--active'] : ''}`} onClick={() => handleItemClick(item)}>
                    <div className={classes.navbar__icon}>
                        <NavbarItemIcon />
                    </div>
                    <span>{t('navigation.' + item.key)}</span>
                    <div className={classes.navbar__icon}>
                        <ChevronRightIcon />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Navbar